<template lang="pug">
b-modal(v-model="showModal", title="Review submission", size="lg", centered scrollable)
    .container
        div(v-if="event.isSingleDay")
            div(v-if="submission.singleDay.whoGoing.length > 0")
                .section-title Attendees
                ul.attendees-list.list-unstyled.pl-0
                    li(v-for="person in submission.singleDay.whoGoing" v-if="person === 'Other Persons' ? submission.singleDay.otherPersons.length > 0 : true" :key="person") 
                        p.font-weight-bold.person-name {{ person === 'Client' ? `${currentClientName()} -` : person === 'Caregiver' ? `${currentCaregiverId()} -` : "" }}  {{ person }}
                        div.food-list(v-if="person === 'Client' && (submission.singleDay.client.lunch || submission.singleDay.client.beverage)").mb-2
                            small.subsection-title Food Choices
                            p.m-0.font-weight-bold {{ submission.singleDay.client.lunch }}
                            p.m-0.font-weight-bold {{ submission.singleDay.client.beverage }}
                        div.food-list(v-if="person === 'Caregiver' && (submission.singleDay.caregiver.lunch || submission.singleDay.caregiver.beverage)").mb-2
                            small.subsection-title Food Choices
                            p.m-0.font-weight-bold {{ submission.singleDay.caregiver.lunch }}
                            p.m-0.font-weight-bold {{ submission.singleDay.caregiver.beverage }}
                        div(v-if="person === 'Other Persons' && submission.singleDay.otherPersons.length > 0")
                            small.subsection-title Other Persons
                            ul.list-unstyled.pl-0
                                li(v-for="(person, index) in submission.singleDay.otherPersons" :key="person.id || person.name || index")
                                    p.m-0.font-weight-bold {{ person?.name }}
                                    div.food-list(v-if="person.lunch || person.beverage").mb-2
                                        small Food Choices
                                        p.m-0.font-weight-bold {{ person.lunch }}
                                        p.m-0.font-weight-bold {{ person.beverage }}
                p.m-0(v-if="submission && submission.remarks") Remarks (If Any): {{ submission.remarks }} 
                // Bottom summary (single day)
                .summary-footer
                    p.mb-1 Attendees: {{ attendeeCount }}
                    p.m-0(v-if="totalSingleDayTotal > 0") Total: $ {{ formatCurrency(totalSingleDayTotal) }} (GST included)
                        
        
        div(v-else)
            div(v-if="submission.multipleDays.whoGoing.length > 0")
                small.section-title Attendees
                ul.attendees-list.list-unstyled.pl-0
                    li(v-for="person in submission.multipleDays.whoGoing" :key="person"
                    v-if="person === 'Other Persons' ? submission.multipleDays.otherPersons.length > 0 : true"
                    ) 
                        p.person-name {{ person === 'Client' ? `${currentClientName()} -` : person === 'Caregiver' ? `${currentCaregiverId()} -` : "" }}  {{ person }}
                        div(v-if="person === 'Client' && submission.multipleDays.client.attendingDays.length > 0").mb-2
                            small.subsection-title Attending Days
                            ul.list-unstyled.pl-0
                                li(v-for="day in submission.multipleDays.client.attendingDays" :key="day") 
                                    p.m-0.font-weight-bold {{ day }}
                                div.food-list(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="submission.multipleDays.client.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))").my-2
                                        small.p.mb-1() Food Choices for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}
                                        b-card-text.m-0.font-weight-bold {{ submission.multipleDays.client.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                                        b-card-text.m-0.font-weight-bold {{ submission.multipleDays.client.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                                        small.p.mb-1.text-primary(v-if="!submission.multipleDays.client.lunchByDay.find(lunch => lunch.dayID === day.id)  && !submission.multipleDays.client.beverageByDay.find(beverage => beverage.dayID === day.id) ") No Food Options Selected for this day
                        div(v-if="person === 'Caregiver' && submission.multipleDays.caregiver.attendingDays.length > 0").mb-2
                            small.subsection-title Attending Days
                            ul.list-unstyled.pl-0
                                li(v-for="day in submission.multipleDays.caregiver.attendingDays" :key="day") 
                                    p.m-0.font-weight-bold {{ day }}
                                div.food-list(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="submission.multipleDays.caregiver.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))").my-2
                                        small.p.mb-1() Food Choices for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}
                                        b-card-text.m-0.font-weight-bold {{ submission.multipleDays.caregiver.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                                        b-card-text.m-0.font-weight-bold {{ submission.multipleDays.caregiver.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                                        small.p.mb-1.text-primary(v-if="!submission.multipleDays.caregiver.lunchByDay.find(lunch => lunch.dayID === day.id)  && !submission.multipleDays.caregiver.beverageByDay.find(beverage => beverage.dayID === day.id) ") No Food Options Selected for this day
                        div(v-if="person === 'Other Persons' && submission.multipleDays.otherPersons.length > 0")
                            ul.list-unstyled.pl-0
                                li(v-for="person in submission.multipleDays.otherPersons" :key="person.id")
                                    p.m-0.font-weight-bold {{ person.name }}
                                    div(v-if="person.attendingDays.length > 0").mb-2
                                        small.subsection-title Attending Days
                                        ul.list-unstyled.pl-0
                                            li(v-for="day in person.attendingDays" :key="day") 
                                                p.m-0.font-weight-bold {{ day }}
                                            div.food-list(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="person.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))").my-2
                                                small.p.mb-1() Food Choices for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}
                                                b-card-text.m-0.font-weight-bold {{ person.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                                                b-card-text.m-0.font-weight-bold {{ person.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                                                small.p.mb-1.text-primary(v-if="!person.lunchByDay.find(lunch => lunch.dayID === day.id)  && !person.beverageByDay.find(beverage => beverage.dayID === day.id) ") No Food Options Selected for this day
                    p(v-if="submission && submission.remarks") Remarks: {{ submission.remarks }} 
                    // Bottom summary (multiple days)
                    .summary-footer
                        p.mb-1 Attendees: {{ attendeeCount }}
                        p.m-0(v-if="totalMultipleDaysTotal > 0") Total: $ {{ formatCurrency(totalMultipleDaysTotal) }} (GST included)
    template(v-slot:modal-footer)
        b-button(type="button" variant="secondary" @click="showModal = false") Make Changes
        b-button(type="button" variant="success" @click="submit") Submit

</template>

<script>
    export default {
        props: {
            show: {
                type: Boolean,
                required: true
            },
            event: {
                type: Object,
                required: true
            },
            submission: {
                type: Object,
                required: true
            },
            totalMultipleDaysCost: {
                type: Number,
                required: true
            },
            totalSingleDayCost: {
                type: Number,
                required: true
            }

        },

        computed:{
            showModal: {
                get(){
                    return this.show;
                },
                set(value){
                    this.$emit('update:show', value);
                }
            },
            isSingleDay(){
                return !!(this.event && this.event.isSingleDay);
            },
            totalSingleDayTotal(){
                const gst = Number(this.event && this.event.gst ? this.event.gst : 0);
                const base = Number(this.totalSingleDayCost || 0);
                return Number(((base * (gst/100)) + base).toFixed(2));
            },
            totalMultipleDaysTotal(){
                const gst = Number(this.event && this.event.gst ? this.event.gst : 0);
                const base = Number(this.totalMultipleDaysCost || 0);
                return Number(((base * (gst/100)) + base).toFixed(2));
            },
            attendeeCount(){
                if (!this.submission) return 0;
                if (this.isSingleDay){
                    const who = this.submission.singleDay && this.submission.singleDay.whoGoing ? this.submission.singleDay.whoGoing : [];
                    const hasOthers = who.includes('Other Persons') && (this.submission.singleDay.otherPersons && this.submission.singleDay.otherPersons.length > 0);
                    return who.filter(p => p !== 'Other Persons').length + (hasOthers ? this.submission.singleDay.otherPersons.length : 0);
                }
                const who = this.submission.multipleDays && this.submission.multipleDays.whoGoing ? this.submission.multipleDays.whoGoing : [];
                const hasOthers = who.includes('Other Persons') && (this.submission.multipleDays.otherPersons && this.submission.multipleDays.otherPersons.length > 0);
                return who.filter(p => p !== 'Other Persons').length + (hasOthers ? this.submission.multipleDays.otherPersons.length : 0);
            }
        },
        watch: {
            show: {
                handler: function (val) {
                    this.showModal = val;
                },
                immediate: true
            },
            event: {
                handler: function (val) {
                    console.log(val);
                },
                immediate: true
            },
            submission: {
                handler: function (val) {
                    console.log(val);
                },
                immediate: true
            }
        },
        methods:{
            submit(){
                this.showModal = false;
                this.$emit('submit');
            },
            currentClientName() {
            return this.$store.state.cli_name;
        },
        currentCaregiverId() {
            return this.$store.state.currentUser[0]?.crb5c_name
        },
        formatCurrency(amount){
            const num = Number(amount || 0);
            return num.toFixed(2);
        }
        }
    }
</script>

<style lang="scss" scoped>

.section-title {
  display: block;
  margin-bottom: 0px;
}
.subsection-title {
  display: block;
}
.person-name {
  font-weight: 600;
}
.summary-footer {
    border-top: 1px solid #e9ecef;
    padding-top: 8px;
    margin-top: 8px;
}

.attendees-list > li {
    background-color: #f7f7f7; // light gray box
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 8px;
    margin-bottom: 8px;
}
.attendees-list > li:last-child {
    margin-bottom: 0;
}
.food-list {
    margin-top: 4px;
}
.food-list p,
.food-list .b-card-text {
    margin-bottom: 2px !important;
}

</style>